<template>
  <div id="panel">
    <div
      v-if="panels.length != 0 || hasCommunityTaxi"
      class="item_container"
    >
      <template v-for="(panel, index) in panels">
        <div
          :key="index"
          class="item"
          :style="{color: panel.TextColor, backgroundColor: panel.BgColor}"
          @click="goLink(panel.Url, panel.Title)"
        >
          {{ panel.Title }}
        </div>
      </template>
      <div
        v-if="hasCommunityTaxi"
        class="item"
        @click="openCommunityTaxi"
      >
        計程車代叫
      </div>
    </div>
    <community-taxi-dialog ref="communityTaxiDialog" />
  </div>
</template>

<script>
import { googleFormTransform } from '@/js/utils'
import CommunityTaxiDialog from './CommunityTaxiDialog'
export default {
  components: {
    CommunityTaxiDialog
  },
  data () {
    return {
      panels: []
    }
  },
  computed: {
    // 是否顯示計程車代叫按鈕
    hasCommunityTaxi () {
      return !!process.env.VUE_APP_COMMUNITY_TAXI_URL
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/Panel/GetPanel`)
      this.panels = res.Panels.map(el => {
        const processedUrl = googleFormTransform.fetchURL(el.Url)
        return {
          ...el,
          Url: processedUrl
        }
      })
      console.log(res)
    },
    goLink (url, title) {
      this.$sendGAEvent('Panel功能使用數', {
        value: `click_${title}`
      })
      if (url === 'https://local.kingnetsmart.com.tw/mgmt/SystemUpdates') {
        const routeData = this.$router.resolve({ name: 'SystemUpdates' })
        window.open(routeData.href, '_blank')
      } else {
        window.open(url, '_blank')
      }
    },
    openCommunityTaxi () {
      this.$sendGAEvent('Panel功能使用數', {
        value: 'click_計程車代叫'
      })
      this.$refs.communityTaxiDialog.open()
    }
  }
}
</script>

<style lang="sass" scoped>
#panel
  margin: -3px auto 0px auto
  width: 100%
  .title
    font-size: 1.67rem
    font-weight: bold
    margin-bottom: 10px
    color: #4B4B4B
  .item_container
    width: 960px
    display: flex
    flex-wrap: wrap
    .item
      width: 213px
      min-height: 78px
      display: flex
      align-items: center
      justify-content: center
      box-sizing: border-box
      text-align: center
      background-color: #fff
      margin-right: 18px
      margin-bottom: 17px
      padding: 13px 40px
      border-radius: 8px
      font-size: 25px
      font-weight: bold
      color: #333333
      border: 1px solid #cccccc
      &:hover
        cursor: pointer
        opacity: .9
      &:last-child
        margin-right: 0px
</style>
